import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { SelectAdoApp } from './SelectAdoAppExtension';

export const SelectAdoAppFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'SelectAdoApp',
    component: SelectAdoApp,
  }),
);
